import { createAction } from 'redux-actions';

export const setInitialLoad = createAction('SET_INITIAL_LOAD');
export const setSearchTerm = createAction('SET_SEARCH_TERM');



// WEBPACK FOOTER //
// ./src/redux/actions/global.js